<template>
  <a-card :bordered='false' class='p-b-80'>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item ref="weight" label="支付成功通知" name="weight">
        <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="checked" @change="onChange" />
      </a-form-item>
      <a-form-item ref="weight" label="发送时间" name="weight">
        <p>买家付款后立即发送。</p>
      </a-form-item>
      <a-form-item label="发送方式">
        <a-checkbox :value="1" v-model:checked="form.sms">
          手机短信 （计费发送，当前短信余额：<span class='s_cd41'>{{$route.query.total}}</span> 条）
        </a-checkbox>
        <a-checkbox value="1" v-model:checked="form.wx" @change="onChangeItem">
          微信公众号
        </a-checkbox>
        <a-checkbox value="1" v-model:checked="form.message" @change="onChangeItem">
          用户消息中心
        </a-checkbox>
        <a-form-item>
          <div class="s_bor10 s_bor_cbed s_over_h mb25">
            <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333 mb25">手机短信模版</p>
            <div class="s_ptb0lr24 m-b-20">
              {{form.sms_content}}
            </div>
            <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333 mb25">微信模版</p>
            <div class="s_ptb0lr24 m-b-20">
              {{form.wx_content}}
            </div>
            <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333 mb25">用户消息中心模版</p>
            <div class="s_ptb0lr24 m-b-20">
              {{form.message_content}}
            </div>
          </div>
          <a-button type="primary" class='m-r-10' @click='save'>
            保存
          </a-button>
          <a-button @click='$router.go(-1)'>
            返回
          </a-button>
        </a-form-item>
      </a-form-item>
    </a-form>

  </a-card>
</template>

<script>
import { detalMessagePush, setmessagePush } from "@/api/message";
import { inject, onMounted, reactive, ref, toRefs } from "vue";
import { iscode } from '../../../utils/app';
const def = {
  wx: 0,
  message: 0,
  sms: 0,
  sms_content: "",
  wx_content: "",
  message_content: "",
};
export default {
  setup() {
    const state = reactive({
      form: {},
      labelCol: { span: 2 },
      wrapperCol: { span: 20 },
      checked: false,
    });
    const form = ref({ def });
    const router = inject("$router");
    const route = inject("$route");
    const content = ref();
    const detail = async () => {
      let result = await detalMessagePush(route.query.id)
        .then((res) => res.data)
        .catch((error) => error);
      form.value = result.data;
      if (form.value.wx && form.value.message) {
        state.checked = true;
      }
    };
    const onChange = (e) => {
      if (e) {
        form.value.wx = 1;
        form.value.message = 1;
      } else {
        form.value.wx = 0;
        form.value.message = 0;
      }
    };
    const onChangeItem=()=>{
      if(form.value.wx&&form.value.message){
        state.checked=true
      }
      if(!form.value.wx&&!form.value.message&&!form.value.sms){
        state.checked=false
      }
    }
    // 保存
    const save=async()=>{
      let result=await  setmessagePush(route.query.id,form.value).then(res=>res.data).catch(error=>error)
      if(iscode(result,true)){
        router.go(-1)
      }
    }
    onMounted(() => {
      detail();
    });
    return {
      ...toRefs(state),
      content,
      form,
      onChange,
      onChangeItem,
      save
    };
  },
};
</script>